import React from "react";
import { Button, Modal } from "react-bootstrap";

export default function DeleteClientModal({ show, t, onClose, onConfirm }) {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("deleteConfirmTitle")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("deleteConfirmBody")}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {t("delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
